/* Function to animate height: auto */
function autoHeightAnimate(element, time) {
  let currentHeight = element.height(), // Get Default Height
    autoHeight = element.css('height', 'auto').height(); // Get Auto Height
  element.height(currentHeight); // Reset to Default Height
  element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
}

export function initAccordion() {
  let accordionContent = $('.js-accordion-content'),
    animateTime = 300,
    accordionHeader = $('.js-accordion-header'),
    $body = $('body'),
    searchFilterResult = $('#js-search-filter-result');

  $body.on('click', function(e) {
    if ($body.hasClass('filter-opened')) {
      if (!$(e.target).closest('.js-accordion-content').length && !$(e.target).hasClass('js-accordion-content')) {
        searchFilterResult.find('.is-opened').addClass('is-closed').removeClass('is-opened');
        $body.removeClass('filter-opened');
      }
    }
  });

  let searchFilterParent = accordionHeader.parent().hasClass('search-filter-filter');
  accordionHeader.click(function (e) {
    $(this).each(function () {
      if ($(this).next(accordionContent).height() === 0) {
        autoHeightAnimate($(this).next(accordionContent), animateTime);
        if (searchFilterParent) {
          $body.addClass('filter-opened');
          searchFilterResult.find('.is-opened').addClass('is-closed').removeClass('is-opened');
          $(this).addClass('is-opened');
          e.stopPropagation();
        } else {
          $(this).addClass('is-opened');
          $(this).removeClass('is-closed');
        }
      } else {
        $(this).next(accordionContent).stop().animate({height: '0'}, animateTime);
        $(this).removeClass('is-opened');
        $(this).addClass('is-closed');

        searchFilterParent ? $body.removeClass('filter-opened') : '';
      }
    });
  });
};

initAccordion();
